import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import image from '@/assets/landing/carnivore-land.webp'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingGenderButtons', 'LandingImage'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: 'Lose weight with a Personalized Carnivore Diet Plan',
			size: 'large',
			customStyles: {
				textAlign: 'center',
				marginLeft: '1.25rem',
				marginRight: '1.25rem',
			},
		}),

		LandingGenderButtons: (): LandingComponentsConfig['LandingGenderButtons'] => ({
			femaleLabel: 'Diet for women',
			maleLabel: 'Diet for men',
		}),

		LandingImage: (): LandingComponentsConfig['LandingImage'] => ({
			img: image,
			customStyles: {
				position: 'fixed',
				bottom: '0',
				left: '0',
				right: '0',
				margin: '0',
			},
		}),
	},
}

export default schema
